import logo from '../../assets/thrifit-logo.svg'

const Logo = () => {
  return (
    <div className=''>
      <img src={logo} className='w-logoWidth object-cover h-logoHeight' alt='thrifit' />
    </div>
  )
}

export default Logo